<template>
    <Button ref="PrimeButton" v-bind="$attrs">
        <span
            v-if="icon.length"
            class="p-button-icon"
            :class="[
                loading ? 'p-button-loading-icon' : '',
                label ? `p-button-icon-${iconPos}` : 'p-button-icon-only',
            ]"
        >
            <font-awesome-icon
                :icon="loading && loadingIcon.length ? loadingIcon : icon"
            />
        </span>
        <span v-if="label" class="p-button-label">{{ label }}</span>
        <span
            v-if="badge"
            :class="
                'p-badge p-badge p-component p-badge-no-gutter ' + badgeClass
            "
        >
            {{ badge }}
        </span>
    </Button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
    name: "FontAwesomeButton",
    props: {
        label: {
            type: String,
        },
        icon: {
            type: Array as PropType<Array<string>>,
            default: () => [],
        },
        iconPos: {
            type: String as PropType<"left" | "right" | "bottom" | "top">,
            default: "left",
        },
        badge: {
            type: String,
        },
        badgeClass: {
            type: String,
        },
        loadingIcon: {
            type: Array as PropType<Array<string>>,
            default: () => ["fas", "faCog"],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
});
</script>
